import 'magnific-popup';
import scrollbar from './scrollbar';

export default function() {
    var defaultOpts = {
        delegate: 'a',
        type: 'image',
        closeMarkup: '<a class="mfp-close"></a>',
        removalDelay: 300,
        mainClass: 'mfp-fade',
        gallery: {
            enabled: true,
            arrowMarkup: '<a title="%title%"  class="mfp-arrow mfp-arrow-%dir%"></a>',
            tPrev: '',
            tNext: '',
            tCounter: '<span class="mfp-counter">%curr% / %total%</span>'
        },
        closeBtnInside: false,
        closeOnContentClick: true,
        closeOnBgClick: false,
        midClick: true,
        image: {
            markup: '<div class="mfp-figure"><div class="mfp-title"></div>' +
                '<div class="mfp-img"></div>' +
                '<div class="mfp-bottom-bar">' +
                '<div class="mfp-description"></div>' +
                '<div class="mfp-counter"></div>' +
                '</div>' +
                '</div>'
        },
        callbacks: {
            open: function() {
                // scrollbar().destroy('html');
            },
            imageLoadComplete: function() {
                $('.mfp-title').html(this.currItem.el.attr('data-title'));
                $('.mfp-description').html(this.currItem.el.attr('data-description'));
            },
            close: function() {
                // scrollbar().create('html', {});
            }
        }
    };

    $('.media-items').each(function(i, val) {
        $('#' + $(this).attr('id')).magnificPopup(defaultOpts);
    });

    $('.photo-feed').magnificPopup(defaultOpts);

    $('.various-content').magnificPopup({
        type: 'image',
        closeMarkup: '<a class="mfp-close"></a>',
        removalDelay: 300,
        mainClass: 'mfp-fade',
        closeBtnInside: false,
        image: {
            markup: '<div class="mfp-figure"><div class="mfp-title"></div>' +
                '<div class="mfp-img"></div>' +
                '<div class="mfp-bottom-bar">' +
                '<div class="mfp-description"></div>' +
                '<div class="mfp-counter"></div>' +
                '</div>' +
                '</div>'
        },
        callbacks: {
            beforeOpen: function() {
                this.st.mainClass = this.st.el.attr('data-effect');
            }
        },
        midClick: true
    });

    $('.notice__item').magnificPopup({
        delegate: 'a',
        closeMarkup: '<a class="mfp-close mfp-close--popup"></a>',
        removalDelay: 500,
        callbacks: {
            beforeOpen: function() {
                this.st.mainClass = this.st.el.attr('data-effect');
            }
        },
        midClick: true
    });

    $('.feedback__confirm').magnificPopup({
        delegate: 'a',
        closeMarkup: '<a class="mfp-close mfp-close--popup"></a>',
        removalDelay: 500,
        callbacks: {
            beforeOpen: function() {
                this.st.mainClass = this.st.el.attr('data-effect');
            }
        },
        midClick: true
    });


    $('.site-map__btn-block').magnificPopup({
        delegate: 'a',
        closeMarkup: '<a class="mfp-close mfp-close--popup"></a>',
        removalDelay: 500,
        callbacks: {
            beforeOpen: function() {
                this.st.mainClass = this.st.el.attr('data-effect');
            }
        },
        midClick: true
    });
}



// WEBPACK FOOTER //
// ./frontend/src/js/modules/lightbox.js